const NAMESPACE = "formSenseHelptext";

const KEYS = {
    helptext: "helptext"
};

const MESSAGES = {
    [KEYS.helptext]: {
        value: "FormSense helps you save time on forms you fill out frequently. Your FormSense defaults are default form values specific to your PowerClerk account. They will not affect other users filling out the same form. Modifying your FormSense defaults will only affect new forms and will not affect forms you have already started.",
        comment:
            "Helptext that explains the purpose and behavior of FormSense defaults. May appear either as static text or within a toggle-able helptext alert"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
